import axios from "axios";


export default function getCep(value) {    

    const cep = value?.replace(/[^0-9]/g, '');

    if (cep?.length !== 8) {
      return Promise.resolve({ erro: true})
    }

    return new Promise( (resolve) => {
        axios.get(`https://viacep.com.br/ws/${cep}/json/`).then(
            response => resolve({ erro: false, ...response.data}),
            error => resolve({ erro: true })
        )
    })

}  